export default __webpack_public_path__ + "static/media/APIntLogo.1c7dba6a.png";